/* Global imports. */
import React from "react";

interface Props {
  id: string;
}

const SoundCloudEmbed = ({ id }: Props) => (
  <div className="relative w-full h-40 max-w-full overflow-hidden">
    <iframe
      src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${id}&amp;color=ff5500`}
      title={id}
      width="100%"
      height="160"
      frameBorder="0"
      scrolling="no"
    />
  </div>
);

export default SoundCloudEmbed;
